export enum FileTypeExporter {
    EXTENSION_CSV_TYPE = "csv",
    EXTENSION_EXCEL = "xlsx"
}

export interface ImportarLibrosResponse {
    insertados: number;
    omitidos: number;
    lista_omitidos: string[];
    errores: number;
    detalle_errores: any[]
}
